import React from 'react'
import PropTypes from 'prop-types'
import { Link as RNLink } from 'react-router-dom'
import Label from './Label'

/**
 * Link is a general label and url which translates the children prop if required.
 * It's color will be set by some parent component. The url prop will provide the 
 * link with the react router whenever the label text is clicked. 
 *
 * @param {object} props see Link.propTypes
 * @returns {Link} - React component
 */
const Link = props => {
  const { url, children, linkStyle, ...finalProps } = props
  return ( 
    <RNLink to={url} style={linkStyle}>
      <Label {...finalProps} >
        {children}
      </Label>
    </RNLink>
  )
}

Link.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Label as a child.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  /**
   Label style,
   */
  style: PropTypes.object,
  /**
   Link style,
   */
  linkStyle: PropTypes.object,
  /**
   Label classname.
   */
  className: PropTypes.string,
  /**
   Prevents the language translation of the children if it is a string.
   */
  noTranslate: PropTypes.bool,
  /**
   MUI color for the Label.
   */
  color: PropTypes.oneOf(['primary', 'default']),
  /**
   url to link to with the react router whenever the label text is clicked. 
   */
  url: PropTypes.string,
}

Link.defaultProps = {
  noTranslate: false
}

export default Link
